import { createApiSlice } from "@common";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CRUD_LEAD, CRUD_LEAD_ALERT, CRUD_LEAD_BY_ID, CRUD_LEAD_BY_OWNER, DOWNLOAD_LEAD, UPLOAD_LEAD } from "@routes";
import axios from "axios";

// ── API config ────────────────────────────────────────────────────────────────
const apiConfig = [
    {
        name: "addLead",
        method: "post",
        url: CRUD_LEAD,
        stateKey: "message",
    },
    {
        name: "getLead",
        method: "get",
        url: CRUD_LEAD,
        stateKey: "data",
    },
    {
        name: "getLeadByOwner",
        method: "get",
        url: CRUD_LEAD_BY_OWNER,
        stateKey: "data",
    },
    {
        name: "updateLead",
        method: "put",
        url: CRUD_LEAD,
        stateKey: "message",
    },
    {
        name: "deleteLead",
        method: "delete",
        url: CRUD_LEAD,
        stateKey: "message",
    },
    {
        name: "leadDeleteAlert",
        method: "get",
        url: CRUD_LEAD_ALERT,
        stateKey: "leadAlertData",
    },
    {
        name: "getLeadDetailsById",
        method: "get",
        url: CRUD_LEAD_BY_ID,
        stateKey: "details",
    },
    {
        name: "uploadLeadFile",
        method: "post",
        url: UPLOAD_LEAD,
        stateKey: "message",
    },
];

// ── Download thunk ─────────────────────────────────────────────────────────────
export const downloadLeadData = createAsyncThunk(
    "lead/downloadLeadData",
    async (data, { rejectWithValue }) => {
        try {
            await axios
                .get(DOWNLOAD_LEAD, {
                    params: data,
                    withCredentials: true,
                    responseType: "blob",
                })
                .then((res) => {
                    const url = globalThis.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Leads.xlsx");
                    document.body.appendChild(link);
                    link.click();
                });
        } catch (err) {
            return rejectWithValue(err.response);
        }
    }
);

// ── Custom reducers ────────────────────────────────────────────────────────────
const customReducers = {
    initialState: {
        data: [],
        details: [],
        leadAlertData: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        [downloadLeadData.pending]: (state) => {
            state.loading = true;
        },
        [downloadLeadData.fulfilled]: (state) => {
            state.loading = false;
        },
        [downloadLeadData.rejected]: (state, action) => {
            state.loading = false;
            state.errMessage = action?.payload?.data?.message;
        },
    },
};

// ── Slice ──────────────────────────────────────────────────────────────────────
const { slice, thunks, actions } = createApiSlice("lead", apiConfig, customReducers);
const leadSlice = slice;

export default leadSlice.reducer;

export const {
    addLead,
    getLead,
    getLeadByOwner,
    updateLead,
    deleteLead,
    leadDeleteAlert,
    getLeadDetailsById,
    uploadLeadFile,
} = thunks;

export const { rowSelect } = actions;
